export const strings = {
  kwh:
    'Kilowatt-hours. A billing unit equivalent to 1kW of power sustained over one hour',
  kvah: 'Kilovolt ampere hours',
  kva: 'Kilovolt-ampere, 1000 volt-amperes',
  mw: 'Megawatts, 1000 kilowatts',
};



// WEBPACK FOOTER //
// ./src/helpers/strings.js